import { PRODUCT_TYPES } from './constants';

// Whether third-party analytics (Amplitude) may run for this user.
//
// The counterpart of st-toosa's utils/analytics-permission.ts. Toosa gated its
// side in DEV-709; peikko was left ungated, which meant a pupil who accepted
// cookies on the consent screen was still identified and tracked here before
// toosa ever saw them — and toosa cannot retract what peikko already sent
// (DEV-712).
//
// Scope: the NATIVE APP ONLY. Google Play's Families Policy binds apps
// distributed through the store, not the web, so a browser visitor is
// unaffected and this returns true outside the shell.
//
// Written as "is this a KNOWN ADULT?" rather than "is this a child?" because
// Google's identifier prohibition covers "children OR USERS OF UNKNOWN AGE".
// Peikko is mostly a pre-login surface, so unknown is the common case and it
// must fail closed.
//
// Deliberately NOT reusing ADULT_PRODUCT_TYPES from constants.ts: that list
// omits PROFESSIONAL and only picks an avatar animation. A teacher is an adult
// here, and borrowing a cosmetic constant for a compliance decision is how the
// two silently diverge later.
const ANALYTICS_ADULT_PRODUCTS: ReadonlySet<string> = new Set([
  PRODUCT_TYPES.PERSONAL,
  PRODUCT_TYPES.PROFESSIONAL,
  PRODUCT_TYPES.MANAGER,
]);

type AnalyticsPermissionInput = {
  product?: string | null;
  isNativeShell: boolean;
};

// Toosa allows some older pupils through a per-country grade-group allowlist.
// Peikko has no grade group — it does not know one until after activation — so
// every pupil is denied here. That is the stricter answer, and it is currently
// the same answer: toosa's FI and GB allowlists are both EMPTY.
//
// If those allowlists are ever populated, this file has to be revisited, or a
// pupil old enough for analytics in toosa will still be invisible in peikko's
// login funnel.
export const isThirdPartyAnalyticsAllowed = ({
  product,
  isNativeShell,
}: AnalyticsPermissionInput): boolean => {
  if (!isNativeShell) return true;
  return Boolean(product && ANALYTICS_ADULT_PRODUCTS.has(product));
};
